import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTicketStatus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	className: "app-icon app-icon--small",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		d: "M19.167 26.693a1.168 1.168 0 002.173.019l3.854-9.248h4.963c.65 0 1.176-.536 1.176-1.197s-.527-1.197-1.176-1.197h-5.742c-.472 0-.898.287-1.083.73l-3.049 7.316-6.856-17.275a1.168 1.168 0 00-2.149-.074L6.847 15.07H1.842c-.65 0-1.176.536-1.176 1.197s.527 1.197 1.176 1.197h5.742c.451 0 .862-.262 1.058-.675l3.596-7.55 6.927 17.454z"
	})
});
export default SvgTicketStatus;
